import React from 'react';
import { Link } from 'react-router';
import { Chip, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIcon from '@material-ui/icons/Assignment';
import TimelineIcon from '@material-ui/icons/Timeline';
import SettingsIcon from '@material-ui/icons/Settings';
import { TEXT, SURFACE } from '../theme';

const NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [{ key: 'dashboard', label: 'Dashboard', icon: HomeIcon, path: '/technical/planner-tracker/dashboard' }],
  },
  {
    title: 'Planning',
    items: [
      { key: 'planner', label: 'Program Planner', icon: AssignmentIcon, path: '/technical/planner-tracker' },
      { key: 'tracker', label: 'Project Tracker', icon: TimelineIcon, path: '/technical/planner-tracker/tracker' },
      { key: 'stages', label: 'Stage Config', icon: SettingsIcon, path: '/technical/planner-tracker/stage-config' },
    ],
  },
];

const useNavRowStyles = makeStyles({
  row: {
    display: 'flex', alignItems: 'center', gap: 12, padding: '9px 15px',
    fontSize: 13.5, lineHeight: 1.3, cursor: 'pointer',
    transition: 'background-color .12s ease, color .12s ease',
    '&:hover': { backgroundColor: SURFACE.hover },
  },
  active: { backgroundColor: '#eef2ff', '&:hover': { backgroundColor: '#eef2ff' } },
});

const NavRow = ({ item, active }) => {
  const classes = useNavRowStyles();
  const Icon = item.icon;
  const row = (
    <div
      className={`${classes.row} ${active ? classes.active : ''}`}
      style={{
        fontWeight: active ? 600 : 500,
        color: active ? '#4f46e5' : item.path ? TEXT.primary : TEXT.tertiary,
        borderLeft: `3px solid ${active ? '#4f46e5' : 'transparent'}`,
        cursor: item.path ? 'pointer' : 'default',
      }}
    >
      <Icon style={{ fontSize: 19, opacity: active ? 1 : 0.85 }} />
      <span style={{ flex: 1 }}>{item.label}</span>
      {!item.path ? (
        <Chip label="Soon" size="small" style={{ height: 19, fontSize: 10, backgroundColor: SURFACE.divider, color: TEXT.tertiary }} />
      ) : null}
    </div>
  );
  if (!item.path) {
    return <Tooltip title="Coming soon" arrow>{row}</Tooltip>;
  }
  return <Link to={item.path} style={{ textDecoration: 'none' }}>{row}</Link>;
};

const PlannerSideNav = ({ activeKey }) => (
  <aside style={{
    height: '100%', minHeight: '90vh', width: 222, flexShrink: 0,
    backgroundColor: '#fff', borderRight: `1px solid ${SURFACE.border}`,
  }}>
    <nav style={{ padding: '16px 0', position: 'sticky', top: 0 }}>
      {NAV_SECTIONS.map((section, index) => (
        <div key={section.title} style={{ marginTop: index === 0 ? 0 : 8 }}>
          <Typography
            variant="caption"
            style={{ display: 'block', padding: '12px 20px 6px', color: TEXT.tertiary, textTransform: 'uppercase', letterSpacing: '.08em', fontWeight: 700, fontSize: 10.5 }}
          >
            {section.title}
          </Typography>
          {section.items.map((item) => <NavRow key={item.key} item={item} active={item.key === activeKey} />)}
        </div>
      ))}
    </nav>
  </aside>
);

export default PlannerSideNav;
